
/* eslint-disable */
// Autogenerated
// -------------
// gulpfile.ts/wasm.ts --> generateBuildInfo

export const Build = {
    version: "8.3.8 (43d10392c19f98b2516b4648b958fb10)",
    buildSeed: 1749214320173,
    "wdosbox-x.wasm": {
        "size": 6672505,
        "gzSize": 0
    },
    "wdosbox-x.js": {
        "size": 223823,
        "gzSize": 0
    },
    "wdosbox.wasm": {
        "size": 1458731,
        "gzSize": 0
    },
    "wdosbox.js": {
        "size": 106006,
        "gzSize": 0
    },
    "wlibzip.wasm": {
        "size": 113073,
        "gzSize": 0
    },
    "wlibzip.js": {
        "size": 74502,
        "gzSize": 0
    }
,
};
